import { createRouter, createWebHistory } from 'vue-router'
import { loading } from '@/utils/loading'
import { traversalRoutes } from '@/utils/router'
import Layout from '@/layout'

// 路由配置
import navs from './raws/nav'
import user from './raws/user'
import out from './raws/out'

// 需要授权布局的路由
export const asyncRoutes = [...user]
// 所有需要布局路由
export const allRoutes = [...navs, ...asyncRoutes]
// 展开嵌套路由
const routes = traversalRoutes(allRoutes)

// 路由
const constantRoutes = [
  {
    path: '',
    redirect: '/home',
    component: Layout,
    children: [...routes]
  },
  ...out,
  { name: '404', path: '/:pathMatch(.*)*', redirect: '/home' }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: constantRoutes
})

router.beforeEach(async (to, _, next) => {
  // 页面初始化加载loading
  if (!window.existLoading) {
    loading.show()
    window.existLoading = true
  }
  if (window.__POWERED_BY_WUJIE__ && _.name) {
    const targetUrl = `${process.env.VUE_APP_SZPX_HOST}${to.href}`
    // 打开新窗口
    window.open(targetUrl)
    next(false)
  } else {
    next()
  }
})

router.afterEach(() => {
  if (window.existLoading) {
    loading.hide()
  }
})

export default router
